import * as ACTION_TYPES from '@engine/actions/action-types';
/**
 * Action Creators for Session Timer
 */

export var resetSessionTimer = function resetSessionTimer() {
  return {
    type: ACTION_TYPES.SESSION_TIMER_RESET
  };
};
export var decrementSessionTimer = function decrementSessionTimer() {
  return {
    type: ACTION_TYPES.SESSION_TIMER_DECREMENT
  };
};